module.exports = __webpack_public_path__ + "img/3078291-78-5.d7ab9717.png";